import * as React from 'react';
import { useEffect, useState, useRef, useMemo } from 'react';
import { Toast, ToastBody, ToastHeader, Table, Input, FormGroup, FormFeedback, Label, TabContent, TabPane, Nav, NavItem, NavLink, Card, Button, CardTitle, CardText, Row, Col } from 'reactstrap';
import Page from '../Page';
import { useAppSelector, useAppDispatch } from '../../hooks/index';
import DropdownTreeSelect from 'react-dropdown-tree-select'
import 'react-dropdown-tree-select/dist/styles.css'
import dateHelper from '../../utils/dateHelper';
import enums from '../../utils/enums';
import { Concept, ConceptRef, ConceptDisplayRef, DimensionalConceptRef, getAccountId } from '../../redux/ConceptSlice';
import { DtsConcept, loadReplacementConcept, getSelectedTaxonomyConcept, getSelectedReplacementConcept, setSelectedReplacementConcept, clearSelectedReplacementConcept, getDeprecationDate, getDeprecationLabel } from '../../redux/TaxonomyConceptSlice';
import { ActiveTaxonomyVersionInfo, selectCurrentVersion, TaxonomyTypeEnum } from '../../redux/TaxonomyVersionSlice';
import { setIsDirty, isAdmin, setDeprecationSubs, getDeprecationSubs } from '../../redux/MiscSlice';
import { ConceptNode, RestrictedAccountsFilter, selectFilteredAccountTree, loadAllAccounts } from '../../redux/AccountsSlice';
import { SelectableListItem } from './BypassRequest';
import { StyledSelectableListItem, getAccountsListMulti } from '../core/ConceptManagementCore';
import { FactInput } from '../../redux/AfrSlice';
import { EditDeprecation } from '../../redux/TaxonomyChangesSlice';
import Select from 'react-select';
import utilityHelper from '../../utils/utilityHelper';


interface DepReplacementProps {
    currentConcept: DtsConcept;
    deprecation: EditDeprecation;
    prompt: string;
    mode: "radioSelect" | "multiSelect" | "simpleSelect" | "hierarchical" | undefined;
    updateDeprecation: (newdep: EditDeprecation) => EditDeprecation
}
const DeprecationReplacementSelector = (props: DepReplacementProps) => {
    const dispatch = useAppDispatch();
    const isAdminUser: boolean = useAppSelector(isAdmin);
    var versionInfo: ActiveTaxonomyVersionInfo | null = useAppSelector(selectCurrentVersion);
    var versionedConcept: DtsConcept | null = props.currentConcept; //useAppSelector(getSelectedTaxonomyConcept);
    const accountTree = useAppSelector(selectFilteredAccountTree);
    const [selectedAccountStatus, setSelectedAccountStatus] = useState("");
    const [substitutionList, setSubstitutionList] = useState<ConceptDisplayRef[]>([]);
    const [replacementSelectionIdList, setReplacementSelectionIdList] = useState<ConceptDisplayRef[]>([]);
    const [selectedAssignedSub, setSelectedAssignedSub] = useState<ConceptDisplayRef | null>(null);
    const [deprecationDirty, setDeprecationDirty] = useState(false);
    const [refreshSubstitutePicker, setRefreshSubstitutePicker] = useState(1);

    const ddhandleChange = function (currentNode: any, selectedNodes: any[] ) {
        var replist: DimensionalConceptRef[] = [];
        selectedNodes.map(n => replist.push({
            conceptName: n.label,
            conceptId: n.value,
            dimensions: [],
            taxonomyType: utilityHelper.getTaxonomyTypeFromVersion(versionInfo),
            afrYear: versionInfo ? versionInfo.year : 2022
        }));
        props.updateDeprecation({ ...props.deprecation, replacements: replist, dirty: true });
    }

    const getMatchingAccountTree = function (currentConcept : DtsConcept, rlist: ConceptDisplayRef[], accountRoots: ConceptNode[] | null) {
        if (!accountRoots) {
            return [];
        }
        if (!versionedConcept || !currentConcept || !currentConcept.concept) {
            return getAccountsListMulti([], accountRoots);
        }
        var matchName = "na";
        switch (currentConcept.concept.code.substring(0, 1)) {
            case "1":
            case "2":
                matchName = "Balance Sheet";
                break;

            case "3":
                matchName = "Revenues";
                break;

            case "5":
            case "6":
            case "7":
                matchName = "Expenditures";
                break;
        }
        var matchRoot = accountRoots.find(acc => acc.concept.name === matchName);
        if (matchRoot) {
            var selections: string[] = [];
            if (rlist) {
                rlist.map(r => selections.push(r.conceptId));
            }
            return getAccountsListMulti(selections, [matchRoot])
        }
        return [];
    }
    const [accountChooserList, setAccountChooserList] = useState<SelectableListItem[]>(getMatchingAccountTree(versionedConcept, [], accountTree));

    const getAssignedSubstitutionList = function (rList: ConceptDisplayRef[]): Array<StyledSelectableListItem> {
        var alist: Array<StyledSelectableListItem> = [];
        if (!versionedConcept || !versionedConcept.concept) {
            return alist;
        }
        if (rList.length > 0) {
            for (var rep of rList) {

                var listItem: StyledSelectableListItem = {
                    parentItem: null,
                    label: rep.conceptName,
                    value: rep.conceptId,
                    disabled: false,
                    checked: false,
                    className: "",
                    children: [],
                    networkid: ""
                }
                alist.push(listItem);
            }
        }
        return alist;
    }
    const [assignedSubstitutionList, setAssignedSubstitutionList] = useState<StyledSelectableListItem[]>(getAssignedSubstitutionList(substitutionList));


    const addSelected = function (node: SelectableListItem, selections: ConceptDisplayRef[]) {
        if (node.children && node.children.length > 0) {
            node.children.map(nc => addSelected(nc, selections));
        }
        if (node.checked) {
            selections.push({
                conceptId: node.value, conceptName: node.label, taxonomyType: utilityHelper.getTaxonomyTypeFromVersion(versionInfo), afrYear : 2022
            });
        }
    }
    const handleAssign = (bRemove: boolean) => {
        if (replacementSelectionIdList.length === 0) {
            return;
        }
        var selections: ConceptDisplayRef[] = [];
        var assignedMap : any = {};
        substitutionList.map(s => assignedMap[s.conceptId] = s);
        var newList: ConceptDisplayRef[] = [...substitutionList];
        replacementSelectionIdList.map(rep =>  assignedMap.hasOwnProperty(rep.conceptId) ? "" : newList.push(rep) );

        newList.sort((a, b) => a.conceptName.localeCompare(b.conceptName));
        setSubstitutionList(newList);
        var replist: DimensionalConceptRef[] = [];
        newList.map(c => replist.push({
            conceptName: c.conceptName,
            conceptId: c.conceptId,
            dimensions: [],
            taxonomyType: utilityHelper.getTaxonomyTypeFromVersion(versionInfo),
            afrYear: c.afrYear
        }));
        props.updateDeprecation({ ...props.deprecation, replacements: replist, dirty: true });
        setAssignedSubstitutionList(getAssignedSubstitutionList(newList));
        setReplacementSelectionIdList([]);
        // Just increment to trigger refresh of sub picker
        setRefreshSubstitutePicker(refreshSubstitutePicker + 1);
        //        setAccountChooserList(getAccountsListMulti([], accountTree));
    }

    const handleRemove = (removeId : string ) => {
        if (substitutionList.length === 0) {
            return;
        }
        if (!removeId) {
            return;
        }
        var newList: ConceptDisplayRef[] = substitutionList.filter(cr => cr.conceptId !== removeId);
        setSubstitutionList(newList);
        var replist: DimensionalConceptRef[] = [];
        newList.map(c => replist.push({
            conceptName: c.conceptName,
            conceptId: c.conceptId,
            dimensions: [],
            taxonomyType: utilityHelper.getTaxonomyTypeFromVersion(versionInfo),
            afrYear: c.afrYear
        }));
        props.updateDeprecation({ ...props.deprecation, replacements: replist, dirty: true });
        setAssignedSubstitutionList(getAssignedSubstitutionList(newList));
    }

    const handleRemoveAll = () => {
        if (substitutionList.length === 0) {
            return;
        }
        props.updateDeprecation({ ...props.deprecation, replacements: [], dirty: true });
        setSubstitutionList([]);
        setAssignedSubstitutionList([]);
    }


    const handleAssignClick = () => {
        handleAssign(false);
    }

    const handleUnAssignClick = () => {
        handleRemoveAll();
    }

    const handleUnAssignItemClick = (event: { target: { value: string; } }) => {
        handleRemove(event.target.value);
    }

    const onDeleteSubstitution = function (event: { target: { value: string; } } ) {
        handleRemove(event.target.value);
    }
    const ddhandleAssignedReplacementChange = function (currentNode: any, selectedNodes: any) {
        if (selectedNodes.length === 0) {
            dispatch(clearSelectedReplacementConcept());
            setSelectedAssignedSub(null);
            return;
        }
        var selNode = selectedNodes[0].value;
        var selRef: ConceptDisplayRef = {
            conceptId: selNode.value,
            conceptName: selNode.label,
            taxonomyType: utilityHelper.getTaxonomyTypeFromVersion(versionInfo),
            afrYear: 2022
        };
        setSelectedAssignedSub(selRef);
        dispatch(clearSelectedReplacementConcept());
    }

    const secondElementStyle = {
        marginTop: '4pt',
        marginLeft: '1em'
    }
    const editButtonStyle = {
        marginTop: '4pt',
        marginLeft: '1em',
        marginBottom: '4pt'
    }
    const leftMarginStyle = {
        marginLeft: '1em'
    }
    const leftTopMarginStyle = {
        marginTop: '8pt',
        marginLeft: '1em'
    }
    const rightAlignStyle = {
        align: 'right'
    }
    const flexRow = {
        display: 'flex'
    }
    const flexRightChild = {
        marginLeft: 'auto',
        marginRight: '1em'
    }
    useEffect(() => {
        setAccountChooserList(getMatchingAccountTree(props.currentConcept, props.deprecation.replacements, accountTree));
    }, [props]);

    const subSelector = useMemo(() => {
        return (
            <DropdownTreeSelect
                mode={props.mode}
                data={accountChooserList}
                keepTreeOnSearch={true}
                onChange={ddhandleChange}
                texts={{ placeholder: props.prompt }} />
        )
    }, [props.currentConcept, accountChooserList, accountTree, refreshSubstitutePicker]);

    return (
        <React.Fragment>
            <Row>
                <Col >
                    <Row>
                        <Col style={{ width: "40%" }}>
                            <h5>
                                {subSelector}
                            </h5>
                            <h4 style={leftTopMarginStyle}>{selectedAccountStatus}</h4>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </React.Fragment>
    );

}
export default DeprecationReplacementSelector;